<div class="form-row" *ngIf="value">
    <mat-form-field class="zipcode">
        <input
            matInput
            type="text"
            autocomplete="postal-code"
            name="zip"
            [(ngModel)]="value.zipcode"
            placeholder="Zip code"
            i18n-placeholder="@@deals.user-profile.placeholder.zipcode"
            (change)="onValueChange()"
            (keyup)="onValueChange()"
            required
            #zipcode="ngModel"
            [disabled]="disabled"
        />
        <mat-error i18n="@@deals.user-profile.validation.zipcode">Invalid zipcode</mat-error>
    </mat-form-field>
</div>

<div class="form-row" *ngIf="value">
    <mat-form-field class="street">
        <input
            matInput
            type="text"
            pattern="^[\w\d\s\.]+$"
            name="address"
            autocomplete="street-address"
            [(ngModel)]="value.street"
            placeholder="Street name"
            i18n-placeholder="@@deals.user-profile.placeholder.street-name"
            required
            maxlength="80"
            [disabled]="disabled"
        />
        <mat-error i18n="@@deals.user-profile.validation.street-name">Invalid answer</mat-error>
    </mat-form-field>
    <mat-form-field class="houseNumber">
        <input
            matInput
            type="number"
            name="house-number"
            [(ngModel)]="value.houseNumber"
            placeholder="House number"
            i18n-placeholder="@@deals.user-profile.placeholder.house-nr"
            maxlength="10"
            (change)="onValueChange()"
            (keyup)="onValueChange()"
            required
            [disabled]="disabled"
        />
        <mat-error i18n="@@deals.user-profile.validation.house-nr">Invalid answer</mat-error>
    </mat-form-field>
    <mat-form-field class="houseNumberSuffix">
        <input
            matInput
            type="text"
            name="houseNumberSuffix"
            [(ngModel)]="value.houseNumberSuffix"
            placeholder="House number suffix"
            i18n-placeholder="@@deals.user-profile.placeholder.house-nr-suffix"
            maxlength="20"
            (change)="onValueChange()"
            (keyup)="onValueChange()"
            [disabled]="disabled"
        />
        <mat-error i18n="@@deals.user-profile.validation.house-nr-suffix">Invalid answer</mat-error>
    </mat-form-field>
</div>
<div class="form-row" *ngIf="value">
    <mat-form-field class="city">
        <input
            matInput
            type="text"
            name="city"
            autocomplete="address-level2"
            [(ngModel)]="value.city"
            placeholder="City"
            i18n-placeholder="@@deals.user-profile.placeholder.city"
            required
            minlength="2"
            maxlength="80"
            [disabled]="disabled"
        />
        <mat-error i18n="@@deals.user-profile.validation.city">Invalid answer</mat-error>
    </mat-form-field>
</div>
